export const groupContentsBySection = (contents, section) => {
  if (Array.isArray(contents) && contents.length > 0) {
    const length = contents.length

    if (length < 2) {
      return []
    }

    if (section === 'featuredArticles') {
      if (length === 2 || length === 3 || length > 5) {
        return contents.slice(0, 2)
      }
    }

    if (section === 'contentList') {
      if (length === 4 || length === 5) {
        return contents.slice(0, 4)
      }
      if (length > 5) {
        return contents.slice(2, 6)
      }
    }
    return []
  } else {
    return []
  }
}
